import { Component, EventEmitter, inject, input, Input, Output } from '@angular/core';
import { UserSearchResult } from '../../models/user.model';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-map-item',
  standalone: false,
  templateUrl: './user-map-item.component.html',
  styleUrl: './user-map-item.component.scss',
})
export class UserMapItemComponent {
  @Input() user!: UserSearchResult;
  listId = input<string>('userItem');

  @Output() close = new EventEmitter<void>();

  private router = inject(Router);
  private translate = inject(TranslateService);

  goToDetails(userId: number): void {
    this.router.navigate(['/users', userId]);
  }

  onClose(event: MouseEvent): void {
    event.stopPropagation();
    this.close.emit();
  }

  // TODO: duplicated
  openWhatsApp($event: MouseEvent, phoneNumber: string | undefined): void {
    $event.stopPropagation();
    if (!phoneNumber) {
      return; // or handle error / show message
    }

    // Remove spaces, dashes, etc.
    let normalized = phoneNumber.replace(/\D/g, '');

    // If number starts with 0, remove it
    if (normalized.startsWith('00')) {
      normalized = normalized.substring(2);
    }

    // Add the link of the current page
    const message = `${this.translate.instant('WHATSAPP_MESSAGE')} ${window.location.href}`;

    const encodedMessage = encodeURIComponent(message);

    const url = `https://wa.me/${normalized}?text=${encodedMessage}`;

    window.open(url, '_blank');
  }
}
